import React, { useCallback, useContext } from 'react';
import { kodplaner_ekkodplaner } from '../KodplanManager/Queries/_QueryTypes/kodplaner';
import { KodplanContext } from '../KodplanManager/Context/KodplanContext';
import Logger from '../../Utils/Logger';
import EDStandardSelect from '../../BaseComponents/Selects/StandardSelect/EDStandardSelect';

const renderValue = (
  value: string,
  availableKodplanList: kodplaner_ekkodplaner[]
) => {
  const activeKodplan = availableKodplanList.find(
    availableKodplan => availableKodplan.id === value
  );

  if (activeKodplan) {
    return activeKodplan.namn;
  }

  return 'Ingen kodplan';
};

/**
 * En komponent för att välja kodplan. Kodplaner hämtas från KodplanContext.
 */
const KodplanPicker: React.FC<React.PropsWithChildren<{}>> = props => {
  const {
    activeKodplan,
    loading,
    error,
    availableKodplanList,
    setActiveKodplan,
  } = useContext(KodplanContext);
  const onChange = useCallback(
    (value: string) => {
      const newActiveKodplan = availableKodplanList.find(
        availableKodplan => availableKodplan.id === value
      );

      if (newActiveKodplan != null) {
        setActiveKodplan(newActiveKodplan);
      } else {
        Logger.error(`Could not find available kodplan with name: ${value}`);
      }
    },
    [availableKodplanList, setActiveKodplan]
  );

  return (
    <EDStandardSelect<string>
      label="Kodplan"
      renderValue={useCallback(
        (value: string) => renderValue(value, availableKodplanList),
        [availableKodplanList]
      )}
      value={
        activeKodplan == null || activeKodplan.id == null
          ? 'error'
          : activeKodplan.id
      }
      items={availableKodplanList.map(kodplan => ({
        header: kodplan.namn || '',
        value: kodplan.id ? kodplan.id : 'error',
      }))}
      onChange={onChange}
      disabled={loading || Boolean(error)}
      error={Boolean(error)}
      testId="kodplan-picker"
    />
  );
};

export default KodplanPicker;
